import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Box,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    textAlign: "center",
    padding: theme.spacing(4),
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  successIcon: {
    fontSize: 80,
    color: theme.palette.success.main,
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  message: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  continueButton: {
    background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
    border: 0,
    borderRadius: 25,
    boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
    color: "white",
    height: 48,
    padding: "0 30px",
    fontSize: "1.1rem",
    fontWeight: "bold",
    "&:hover": {
      background: "linear-gradient(45deg, #1976D2 30%, #1CB5E0 90%)",
    },
  },
  celebration: {
    fontSize: "3rem",
    marginBottom: theme.spacing(1),
  },
}));

const CongratulationsModal = ({ open, onClose, companyName }) => {
    const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 20,
        },
      }}
    >
      <DialogTitle>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.celebration}>🎉</div>
        <CheckCircleIcon className={classes.successIcon} />
        
        <Typography variant="h4" className={classes.title}>
          {i18n.t("congratulations.title")}
        </Typography>
        
        <Typography variant="h6" className={classes.message}>
          {i18n.t("congratulations.message", { companyName })}
        </Typography>
        
        <Typography variant="body1" className={classes.message}>
          {i18n.t("congratulations.description")}
        </Typography>
        
        <Box mt={3}>
          <Button
            className={classes.continueButton}
            onClick={onClose}
            variant="contained"
            size="large"
          >
            {i18n.t("congratulations.button")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CongratulationsModal;